import { Backdrop, Box, Button, Modal, Typography } from "@mui/material";
import { useContext } from "react";
import { ModalContext } from "../LosListe";

export default function PleaseSelect() {
  const { modalOpened, handleClose } = useContext(ModalContext);
  return (
    <Backdrop sx={{ zIndex: 1200 }} open={modalOpened} onClick={() => handleClose()}>
      <Modal hideBackdrop open={modalOpened} onClose={() => handleClose()} aria-labelledby="modal-title">
        <Box sx={{
          width: "30%",
          minWidth: "300px",
          maxWidth: "90%",
          position: "absolute",
          top: "50%",
          left: "50%",
          backgroundColor: "white",
          transform: "translate(-50%, -50%)",
          borderRadius: "16px",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          padding: 4,
          textAlign: "center",
        }}>
          <Typography fontSize={20} fontWeight={"bold"}>
            Sie müssen erst Lose auswählen um sie zu bearbeiten.
          </Typography>
          <Button
            onClick={() => {
              handleClose()
            }}
            sx={{
              flexGrow: 1,
              borderRadius: "26px",
              color: "#072D26",
              fontWeight: "bold",
              border: "2px solid #C0D904",
              height: "51px",
              paddingLeft: "50px",
              paddingRight: "50px",
              "&:hover": { background: "#c0d904" }
            }}>
            Fortfahren
          </Button>
        </Box>
      </Modal>
    </Backdrop>
  )
}